module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1312-retro.e6d07d72.jpg";